// extracted by mini-css-extract-plugin
module.exports = {"banner":"style_banner__5aZ3R","isCenter":"style_isCenter__2myiW","bannerInfoBox":"style_bannerInfoBox__MbhOA"};